var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreePoints2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4519 19.3748V39.3699C47.4389 39.6121 47.3688 39.8478 47.2475 40.0578C47.1261 40.2677 46.9569 40.4461 46.7536 40.5783L46.0986 40.97C42.8302 42.8616 39.9535 44.5266 37.0468 46.2033V24.5798L18.3251 13.7564C21.5651 11.8964 24.7934 10.0181 28.0368 8.16641C28.253 8.057 28.492 8 28.7343 8C28.9766 8 29.2156 8.057 29.4318 8.16641L47.4486 18.5715V19.3748H47.4519ZM32.8835 26.9782C28.6101 24.5073 24.3357 22.0384 20.0601 19.5715C19.8433 19.4637 19.6046 19.4076 19.3626 19.4076C19.1205 19.4076 18.8818 19.4637 18.6651 19.5715C15.7767 21.2398 12.8867 22.9048 10 24.5782L23.5218 32.3849V48C26.4084 46.335 29.2885 44.6566 32.1835 43.0083C32.3863 42.876 32.5552 42.6978 32.6765 42.4882C32.7978 42.2786 32.8681 42.0434 32.8818 41.8016L32.8835 26.9782ZM10.0017 40.1949L19.3567 45.5966V34.7832L10.0017 40.1949Z",
    fill: "#1CCEDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreePoints2);
export default __webpack_public_path__ + "static/media/threePoints2.6bb4a07b38704b72ce335498b99d4446.svg";
export { ForwardRef as ReactComponent };